import { useContext } from 'react'
import { FormContext } from '../FormContext'

// This must be used within a <Form.Root> element
export const useForm = () => {
  const { formData, errors, setErrors, hasErrors, setFormData } = useContext(FormContext)

  return { formData, errors, setErrors, hasErrors: hasErrors(), setFormData }
}
